function formatBot(config) {
    const textBubbleHtml = `<span id="chat-bot-message-ui" class="crm-ai-agent-text-bubble">${config?.extra_config?.text_bubble}</span>`;
    setTimeout(() => {
        const textEl = document.getElementById('chat-bot-message-ui');
        if (textEl) {
            textEl.style.transition = 'opacity 0.5s ease';
            textEl.style.opacity = '0';
            setTimeout(() => textEl.remove(), 500);
        }
    }, 30000);
    const validateAttachment = Object.values(with_attachment).some((value) => value);
    let paddingValue = '';
    switch (true) {
        case is_microphone && validateAttachment:
            paddingValue = '104px';
            break;
        case is_microphone || validateAttachment:
            paddingValue = '74px';
            break;
        default:
            paddingValue = '32px';
            break;
    }

    return `<style>

       .cms-btn-link {
         border: none;
         background: none;
         cursor: pointer;
         color:  black;
       }

         .custom-select-agent {
    position: relative;
    width: 123px;
    font-family: sans-serif;
    cursor: pointer;
  }

  .custom-select-agent .selected-agent {
    border: 1px solid #e8e8e8;
    padding: 10px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: white;
  }

  .custom-select-agent .selected-agent span {
    display: flex;
    align-items: center;
  }

  .custom-select-agent img {
    margin-right: 5px;
  }

  .custom-select-agent .options-agent {
    display: none;
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    height: 160px;
    overflow-y: auto;
    border: 1px solid #ccc;
    background: white;
    z-index: 10;
  }

  .custom-select-agent .option-agent {
    padding: 8px;
    display: flex;
    align-items: center;
  }

  .custom-select-agent .option-agent:hover {
    background: #f0f0f0;
  }

  .custom-select-agent.open .options-agent {
    display: block;
  }

    .custom-select-agent.disabled {
        pointer-events: none;
        opacity: 0.6;
    }


    .crm-ai-agent-icon {
        bottom: 20px;
        right: 20px;
        display: flex;
        align-items: center;
        transition: all .5s;
        position: ${config.position !== 'fixed' ? 'absolute' : 'fixed'};
        z-index: 900;
        gap: 6px;
        scale: 110%;
        cursor: pointer;
        font-family: sans-serif;
    }
    
    .toggle-bot-content {
         display: flex;
         justify-content: center;
         align-items: center;
         width: 40px;
         height: 40px;
         border-radius: 50%;
         border: 2px solid #ffffff;
         box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
         color: white;
         background: ${config.backgroundReceive};
     }

    .crm-ai-agent-icon:hover {
        animation: rotate-bot 3s infinite;
    }

    .crm-ai-agent-text-bubble {
        background: #f2f2f2;
        color: #000;
        padding: 6px 12px;
        border-radius: 14px;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
        font-size: 14px;
        max-width: 250px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    
    .crm-ai-agent-icon:after {
    ${isPreview ? 'display: none;' : ''};
     content: '';
     background: #1a7f37;
        width: 10px;
        height: 10px;
        position: absolute;
        top: -5px;
        right: -5px;
        border-radius: 50%;
        animation: pulse-online 2s infinite;
    }
    
  @keyframes pulse-online {
    0% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
    }

    70% {
        transform: scale(1);
        box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
    }

    100% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
    }
}
    
  
    .ai-agent-rounded-full {
        border-radius: 50%;
        overflow: hidden;
    }
    }

    .ai-agent-relative {
        position: relative;
    }

    .ai-agent-absolute {
        position: absolute;
    }
    
     @keyframes rotate-bot {
      0% {
        transform: scale(1);
      }

      50% {
        transform: ${config?.extra_config?.text_bubble ? 'scale(1.1)' : 'scale(1.3)'};
      }
      
      100% {
        transform: scale(1);
      }
        
    }

    .crm-ai-agent-icon:active {
        transform: scale(1);
    }

    .crm-ai-agent-icon img {
        height: 62px;
        border-radius: 50%;
    }

    .ai-agent-chat-content {
        position: ${config.position || 'fixed'};
       ${config.position !== 'relative' ? 'z-index: 900; right: 50px;' : ''};

        width: 360px;
        max-width: 100%;
        height: 587px;
        background: ${config.background};
        border-radius: 15px;
        overflow: hidden;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        transition: all .5s;
        display: flex;
        flex-direction: column;
        border: 1px solid ${config.backgroundReceive};
    }

    .ai-agent-chat-body {
        height: 310px;
        display: flex;
        flex-direction: column;
        padding: 10px 13px 10px 10px;
        overflow: auto;
        // background: ${config.backgroundChat};
        scroll-behavior: smooth;
    }

    .ai-agent-chat-body::-webkit-scrollbar {
        width: 2px;
    }

    .ai-agent-chat-body::-webkit-scrollbar-thumb {
        background: gray;
    }

    .ai-agent-chat-footer {
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px 0 20px;
        // border-top: 1px solid ${config.colorBorderInputTop};
        // border-bottom: 1px solid ${config.colorBorderInputBottom};
    }

    .ai-agent-data {
        display: flex;
        flex-direction: column;
        margin-bottom: 10px;
        width: 100%;
        font-size: 13px;
    }

    .ai-agent-data-left {
        transition: all .5s;
        padding: 10px;
        max-width: 90%;
        background: ${config.backgroundReceive};
        color: ${config.colorReceive};
        border-radius: 8px;
        width: fit-content;
        border: 1px solid #EAEAEA;
    }

    .ai-agent-data-right {
        padding: 10px;
        max-width: 90%;
        background: ${config.backgroundSend};
        color: ${config.colorSend};
        border-radius: 8px;
        width: fit-content;
        margin-left: auto;
        text-align: right;
        border: 1px solid #EAEAEA;
    }

    .ai-agent-time-left {
        font-size: 10px;
        color: ${config.timeColor};
        margin-top: 10px;
        margin-left: 39.7px;
    }

    .ai-agent-time-right {
        font-size: 10px;
        width: fit-content;
        color: ${config.timeColor};
        margin-top: 10px;
        margin-left: auto;
    }

    .ai-agent-responsible-right {
        justify-content: right;
    }

    .ai-agent-responsible-left img {
        width: 34.7px;
        height: fit-content;
        margin-right: 5px;
        margin-top: 5px;
    }

    .ai-agent-responsible-right img {
        width: 20px;
        height: 20px;
        margin-left: 5px;
    }

    .ai-agent-chat-content[aria-open="true"] {
       ${isPreview ? 'bottom: 20px;' : 'bottom: 60px;'}
       
        transform: scale(1);
        opacity: 1;
    }

    .ai-agent-chat-content[aria-open="false"] {
       transform: scale(0);
       bottom: -200px;
       right: -100px;
       opacity: .5;
    }

    .ai-agent-chat-content[aria-open="true"] ~ .crm-ai-agent-icon .toggle-bot-content {
     
      ${isPreview ? 'display: none;' : ' display: flex;'}
      animation: rotate 1s;
    }
    
    @keyframes rotate {
      from {
        transform: rotate(0deg);
      }
      to {
       transform: rotate(180deg);
      }
    }
       
    .ai-agent-chat-content[aria-open="false"] ~ .crm-ai-agent-icon .toggle-bot-content {
         display: none;
    }
    
    .ai-agent-chat-content[aria-open="true"] ~ .crm-ai-agent-icon img {
         display: none;
    }

    .ai-agent-chat-header {
        display: flex;
        padding: 0 5px 0 20px;
        justify-content: space-between;
        align-items: center;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        font-size: 14px;
        background: ${config.extra_config?.header_bg_color || 'linear-gradient(90deg, #E3007E 0%, #3C8DFF 100%)'};
        height: 48px;
    }
    
    .ai-agent-messages-body {
        height: 85%;
    }

    .ai-agent-flex {
        display: flex;
    }

    .ai-agent-items-center {
        align-items: center;
    }

    .ai-agent-justify-between {
        justify-content: space-between;
    }

    .ai-agent-justify-center {
        justify-content: center;
    }

    .ai-agent-justify-end {
        justify-content: end;
    }

    .ai-agent-w-full {
        width: 100%;
    }

    .ai-agent-h-full {
        height: 100%;
    }

    .ai-agent-cursor-pointer {
        cursor: pointer;
    }

    .ai-agent-input {
        width: 100%;
        padding: 15px ${paddingValue} 15px 15px;
        outline: none;
        border-radius: 10px;
        font-size: 13px;
        border: 1px solid ${config.colorBorderInputTop};
    }

    .ai-agent-input:focus {
        border: 1px solid ${config.inputFocus};
    }
    
    .container-buttons {
        position: absolute;
        right: 10px;
        top: calc(50% - 14px);
        display: flex;
        align-items: center;
        gap: 7px;
    }

    .button-send {
        color: ${config.iconSendColor};
        line-height: 12px;
        height: 28px;
    }
    
    .button-microphone {
        color: ${config.iconSendColor};
        fill: ${config.iconSendColor};
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 30px;
        height: 28px;
        transition: all .5s;
        border: 1px solid transparent !important;
    }
    
    .button-attachment {
        color: ${config.iconSendColor};
        fill: ${config.iconSendColor};
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 30px;
        height: 28px;
        transition: all .5s;
        border: 1px solid transparent !important;
    }

    .ai-agent-suggestion-content {
        display: flex;
        justify-items: center;
        align-items: center;
        overflow-x: hidden;
        margin: 0 20px 10px 20px;
        padding-left: 5px;
        border-radius: 8px;
        border: 1px solid #e8e8e8;
        background: white;
        scroll-behavior: smooth;
        height: 40px;
        transition: all .5s;
        white-space: nowrap;
    }

    .ai-agent-suggestion-content:hover {
        overflow-x: auto;
    }

    .ai-agent-suggestion-content::-webkit-scrollbar {
        height: 2px;
    }

    .ai-agent-suggestion-content::-webkit-scrollbar-thumb {
        background: gray;
    }

    .ai-agent-suggestion-item {
        padding: 5px;
        margin-right: 5px;
        border-radius: 10px;
        background: #f5f5f5;
        font-size: 10px;
        color: gray;
        cursor: pointer;
    }

    .ai-agent-waiting {
        animation: pulse 2s infinite;
        overflow: hidden;
        white-space: nowrap;
        word-break: auto-phrase;
        padding-right: 20px;
    }
    
    .ai-agent-response {
       animation: expand .2s;
       animation-iteration-count: 1;
    }

    @keyframes pulse {
        from {
            opacity: .5;
            scale: 100%;
        }
        to {
            opacity: 1;
            scale: 110%;
        }
    }
    
    @keyframes expand {
        from {
         scale: 10%;
        }
        to {
            scale: 100%;
        }    
    }
    

    .ai-agent-form-body {
      padding: 10px;
      height: 88%;
      font-size: 13px;
      justify-items: center;
      align-items: center;
    }

    .ai-agent-form-group {
      margin-bottom: 10px;
    }

    .ai-agent-form-control {
      width: 100%;
      padding: 10px;
      border: 1px solid #e8e8e8;
      border-radius: 10px;
      outline: none;
    }
    
    .ai-agent-link {
        color: #0486e4 !important;
        text-underline: #0486e4 !important;
    }

    .ai-agent-link-receive {
        color: white !important;
        text-underline: white !important;
    }

    *:disabled {
      cursor: not-allowed;
      opacity: .5;
    }

    .ai-agent-form-control:active {
      border: 1px solid #0486e4;
    }

    .ai-agent-session-submit {
       background: ${config.iconSendColor};
       color: white;
       border: none;
       padding: 10px;
       border-radius: 10px;
       width: 100%;
       cursor: pointer;
    }

    input:invalid{
        border: 1px solid #fb6969 !important;
    }

    .ai-agent-assessor-action {
        padding: 10px;
        font-size: 12px;
        border: 1px solid ${config.colorBorderInputTop};
        border-radius: 58px;
        gap: 6px;
    }

    .ai-agent-assessor-action:hover {
        background: #f5f5f5;
    }

    .ai-agent-assessor-bubble {
        width: 30px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: ${config.iconSendColor};
        color: white;
        padding-bottom: 1px;
        margin-right: 5px;
        margin-top: 6px;
    }

    .headphone{
      animation-iteration-count: infinite;
      animation: headphone 1s infinite;
      fill: ${config.iconSendColor};
    }

    .headphone:hover {
        animation: none;
    }

    @keyframes headphone {
      0% {
        transform: rotate(0deg);
      }

      50% {
        transform: rotate(10deg);
      }

      100% {

        transform: rotate(0deg);
      }
    }
    
   
    
    .button-microphone-active {
        border: 1px solid ${config.iconSendColor} !important;
    }

    .ai-agent-menu-options-action {
        cursor: pointer;
        transition: all .5s;
        position: relative;
    }
    
    .ai-agent-menu-options-action:hover {
        scale: 1.3;
    }
    
    .ai-agent-menu-options {
      position: absolute;
      background: white;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
      padding: 5px;
      border-radius: 5px;
      transition: scale .5s, opacity .5s;
      opacity: 0;
      top: 28px;
      right: 10px;
      scale: 0;
      display: flex;
      flex-direction: column;
      z-index: 10;
    }
    
    .ai-agent-menu-options-action:hover + .ai-agent-menu-options,  .ai-agent-menu-options:hover  {
        scale: 1;
        opacity: 1;
        right: 10px;
    }
    
    .ai-agent-menu-options-item {
        padding: 5px;
        cursor: pointer;
        font-size: 12px;
    }
    
    .ai-agent-menu-options-item:hover {
        background: #f5f5f5;
    }
   
    #ai-agent-icon-id-close-${idAgent} {
      ${session ? 'display: none;' : ''}
      margin-right: 5px;
    }
    
    #ai-agent-menu-options-action-${idAgent} {
        ${!session ? 'display: none;' : ''}
    }

    .agent-loader {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 8px;
    }

    .agent-loader span {
        width: 5px;
        height: 5px;
        background-color: #fff;
        border-radius: 50%;
        animation: agent-bounce 2s infinite ease-in;
    }

    .agent-loader span:nth-child(2) {
        animation-delay: 0.2s;
    }

    .agent-loader span:nth-child(3) {
        animation-delay: 0.4s;
    }

    @keyframes agent-bounce {
        0%, 100% {
            transform: scale(0);
        }
        50% {
            transform: scale(1);
        }
    }
    
    .chatbot-container {
      position: fixed;
      z-index:  900;
      background: rgb(255,255,255);
      border-radius: 16px;
      padding: 20px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
      animation: slideUp 0.6s ease-out;
      right: 20px;
      bottom: 100px;
    }

    .chatbot-popup {
      max-width: 300px;
      animation: fadeIn 0.8s ease-in;
    }

    .chatbot-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
      margin-bottom: 10px;
    }

    .chatbot-header img {
      height: 24px;
    }

    .chatbot-message {
      font-size: 16px;
      margin-bottom: 16px;
    }

    .chatbot-buttons {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
    }
    
    .agent-caret-down {
       position: absolute;
       right: 5px;
    }

    .chatbot-buttons button {
      padding: 10px 16px;
      border: none;
      border-radius: 24px;
      background-color: #f2f2f2;
      cursor: pointer;
      font-size: 12px;
      transition: background-color 0.3s;
     
    }

    .chatbot-buttons button:hover {
      background-color: #e0e0e0;
    }

    @keyframes fadeIn {
      0% { opacity: 0; transform: translateY(20px); }
      100% { opacity: 1; transform: translateY(0); }
    }

    @keyframes slideUp {
      0% { transform: translateY(100px); opacity: 0; }
      100% { transform: translateY(0); opacity: 1; }
    }
    
    .chatbot-container[aria-open="false"] {
        display: none;
    }
    
    [bot-aria-hidden="true"] {
        display: none  !important;
    }
    
    .ai-agent-gap-5 {
        gap: 5px;
    }
    
</style>

 ${
     config?.extra_config?.roles_options?.length
         ? `<div bot-aria-hidden="${session?.isAssessor}" aria-open="${!isPreview}" id="role-${idAgent}" class="chatbot-container">
        <div class="chatbot-popup">
            <div class="chatbot-header">
                <div class="ai-agent-flex ai-agent-items-center ai-agent-gap-5">
                    <img src="${config.receiveIcon}" alt="Nord Icon">
                    <div>
                        <strong>${config?.extra_config?.role_title || ''}</strong>
                    </div>
                </div>
                <div>
                  <button id="role-content-action-close-${idAgent}" class="cms-btn-link">
                    <svg id="close-chatbot-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#000"/>
                    </svg>
                  </button>
                </div>
                
                
            </div>
            <div class="chatbot-message">
                ${config?.extra_config?.role_message || ''}
            </div>
            <div class="chatbot-buttons">
                ${config?.extra_config?.roles_options?.map((role) => `<button role-button="${idAgent}">${role}</button>`).join('')}
            </div>
        </div>
    </div>`
         : ''
 }
<div id="${idAgent}" aria-open="${isPreview}" class="ai-agent-chat-content">
    <div class="ai-agent-chat-header">
        <div class="ai-agent-flex ai-agent-items-center ai-agent-justify-between">
                <span  style="margin-right: 5px;  justify-content: center; display: flex; align-items: center">
                    <img style="margin-right: 5px; width: ${config.extra_config?.logo_width ?? '25'}px; height: 25px;" class="ai-agent-h-full ai-agent-w-full" draggable="false"
                         src="${config?.extra_config?.logo_header || 'data:image/png;base64,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'}" alt="">
                       <b style="color: ${config.extra_config?.header_text_color ?? '#ffffff'}">
                         ${config.agentName}
                       </b>
                </span>
        </div>
       <div class="ai-agent-flex ai-agent-items-center">
        <span id="ai-agent-icon-id-close-${idAgent}" class="ai-agent-cursor-pointer crm-ai-agent-icon-close">
               <svg
                   fill="${config.extra_config?.header_menu_color ?? '#ffffff'}"
                   height="15px" id="Layer_1" style="enable-background:new 0 0 512 512;"
                   viewBox="0 0 512 512" width="15px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
                   <path d="M443.6,387.1L312.4,255.4l131.5-130c5.4-5.4,5.4-14.2,0-19.6l-37.4-37.6c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4  L256,197.8L124.9,68.3c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4L68,105.9c-5.4,5.4-5.4,14.2,0,19.6l131.5,130L68.4,387.1  c-2.6,2.6-4.1,6.1-4.1,9.8c0,3.7,1.4,7.2,4.1,9.8l37.4,37.6c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1L256,313.1l130.7,131.1  c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1l37.4-37.6c2.6-2.6,4.1-6.1,4.1-9.8C447.7,393.2,446.2,389.7,443.6,387.1z"/></svg>
        </span>
        <span id="ai-agent-menu-options-action-${idAgent}" class="ai-agent-menu-options-action">
             <svg id="Glyph" style="width: 15px; height: 15px;" fill="${config.extra_config?.header_menu_color ?? '#ffffff'}"  viewBox="0 0 32 32" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13,16c0,1.654,1.346,3,3,3s3-1.346,3-3s-1.346-3-3-3S13,14.346,13,16z" id="XMLID_294_"/>
                  <path d="M13,26c0,1.654,1.346,3,3,3s3-1.346,3-3s-1.346-3-3-3S13,24.346,13,26z" id="XMLID_295_"/>
                  <path d="M13,6c0,1.654,1.346,3,3,3s3-1.346,3-3s-1.346-3-3-3S13,4.346,13,6z" id="XMLID_297_"/>
             </svg>
        </span>
         <span class="ai-agent-menu-options">
        
            <span class="ai-agent-menu-options-item" id="minimize-agent-action-${idAgent}">
               ${config?.extra_config?.minimized_chat_text || ''}
            </span>
            <span class="ai-agent-menu-options-item" id="finalize-agent-action-${idAgent}" >
              ${config?.extra_config?.finalized_chat_text || ''}
            </span>
       
     </span>
      </div>
    </div>
    <div style="${!session ? 'display:none; ' : ''}" class="ai-agent-messages-body">
        <div class="ai-agent-chat-body">
          <p class="animation-appear" style="text-align: center; font-size: 13px">
          </p>
        </div>
    
    <div id="ai-agent-waiting-and-assessor-${idAgent}" style="padding: 0 20px 0 20px" class="ai-agent-flex ai-agent-items-center ai-agent-justify-between">
      <div style="opacity: 0" id="ai-agent-waiting-message-${idAgent}" class="ai-agent-flex ai-agent-items-center">
        <img width="50px" src="${domainImagesUrl.concat('images/giphy.gif')}" alt="waiting" />  
      </div>
      <div id="ai-agent-assessor-action-${idAgent}"
           title="${config?.extra_config?.comunication_with_assesor_title || ''}"
           style="${session?.isAssessor || !with_assessor ? 'display:none;' : ''}"
           class="ai-agent-assessor-action ai-agent-flex ai-agent-items-center ai-agent-cursor-pointer">
        ${config?.extra_config?.comunication_with_assesor_title || ''}
        <svg class="headphone" xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14">
        <path d="M8 0.25C7.01509 0.25 6.03982 0.443993 5.12987 0.820904C4.21993 1.19781 3.39314 1.75026 2.6967 2.4467C1.29018 3.85322 0.5 5.76088 0.5 7.75V13C0.5 13.1989 0.579018 13.3897 0.71967 13.5303C0.860322 13.671 1.05109 13.75 1.25 13.75H3.5C4.09674 13.75 4.66903 13.5129 5.09099 13.091C5.51295 12.669 5.75 12.0967 5.75 11.5V10C5.75 9.40326 5.51295 8.83097 5.09099 8.40901C4.66903 7.98705 4.09674 7.75 3.5 7.75H2C2 6.1587 2.63214 4.63258 3.75736 3.50736C4.88258 2.38214 6.4087 1.75 8 1.75C9.5913 1.75 11.1174 2.38214 12.2426 3.50736C13.3679 4.63258 14 6.1587 14 7.75H12.5C11.9033 7.75 11.331 7.98705 10.909 8.40901C10.4871 8.83097 10.25 9.40326 10.25 10V11.5C10.25 12.0967 10.4871 12.669 10.909 13.091C11.331 13.5129 11.9033 13.75 12.5 13.75H14.75C14.9489 13.75 15.1397 13.671 15.2803 13.5303C15.421 13.3897 15.5 13.1989 15.5 13V7.75C15.5 5.76088 14.7098 3.85322 13.3033 2.4467C11.8968 1.04018 9.98912 0.25 8 0.25ZM3.5 9.25C3.69891 9.25 3.88968 9.32902 4.03033 9.46967C4.17098 9.61032 4.25 9.80109 4.25 10V11.5C4.25 11.6989 4.17098 11.8897 4.03033 12.0303C3.88968 12.171 3.69891 12.25 3.5 12.25H2V9.25H3.5ZM14 12.25H12.5C12.3011 12.25 12.1103 12.171 11.9697 12.0303C11.829 11.8897 11.75 11.6989 11.75 11.5V10C11.75 9.80109 11.829 9.61032 11.9697 9.46967C12.1103 9.32902 12.3011 9.25 12.5 9.25H14V12.25Z"/>
</svg>
      </div>
    </div>
    <div class="ai-agent-suggestion-content">
        <small style="font-size: 10px;color: gray;">${config?.extra_config?.loading_suggestions_message || ''}</small>
    </div>
    <form></form>
    <form  id="form-${idAgent}"  class="ai-agent-chat-footer">
        <label style="width: 100%; position: relative">
            <input maxlength="200" autocomplete="off" id="ai-agent-input-message" oninput="this.value = this.value.slice(0, 200)" 
            type="text" placeholder="${config.placeholder}"
                   class="ai-agent-input">
                   <div class="container-buttons">
            ${
                is_microphone
                    ? `<button style="border: 1px solid " button-microphone id="ai-agent-id-microphone-${idAgent}" class="button-microphone "
                    style="outline: none; border: none; background: none">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="18" viewBox="0 0 12 18"">
                    <path d="M6 11.25C6.79565 11.25 7.55871 10.9339 8.12132 10.3713C8.68393 9.80871 9 9.04565 9 8.25V3.75C9 2.95435 8.68393 2.19129 8.12132 1.62868C7.55871 1.06607 6.79565 0.75 6 0.75C5.20435 0.75 4.44129 1.06607 3.87868 1.62868C3.31607 2.19129 3 2.95435 3 3.75V8.25C3 9.04565 3.31607 9.80871 3.87868 10.3713C4.44129 10.9339 5.20435 11.25 6 11.25ZM4.5 3.75C4.5 3.35218 4.65804 2.97064 4.93934 2.68934C5.22064 2.40804 5.60218 2.25 6 2.25C6.39782 2.25 6.77936 2.40804 7.06066 2.68934C7.34196 2.97064 7.5 3.35218 7.5 3.75V8.25C7.5 8.64782 7.34196 9.02936 7.06066 9.31066C6.77936 9.59196 6.39782 9.75 6 9.75C5.60218 9.75 5.22064 9.59196 4.93934 9.31066C4.65804 9.02936 4.5 8.64782 4.5 8.25V3.75ZM12 8.25C12 8.05109 11.921 7.86032 11.7803 7.71967C11.6397 7.57902 11.4489 7.5 11.25 7.5C11.0511 7.5 10.8603 7.57902 10.7197 7.71967C10.579 7.86032 10.5 8.05109 10.5 8.25C10.5 9.44347 10.0259 10.5881 9.18198 11.432C8.33807 12.2759 7.19347 12.75 6 12.75C4.80653 12.75 3.66193 12.2759 2.81802 11.432C1.97411 10.5881 1.5 9.44347 1.5 8.25C1.5 8.05109 1.42098 7.86032 1.28033 7.71967C1.13968 7.57902 0.948912 7.5 0.75 7.5C0.551088 7.5 0.360322 7.57902 0.21967 7.71967C0.0790178 7.86032 0 8.05109 0 8.25C0.00132434 9.71047 0.535291 11.1203 1.5018 12.2152C2.46831 13.3101 3.80098 14.0149 5.25 14.1975V15.75H3.75C3.55109 15.75 3.36032 15.829 3.21967 15.9697C3.07902 16.1103 3 16.3011 3 16.5C3 16.6989 3.07902 16.8897 3.21967 17.0303C3.36032 17.171 3.55109 17.25 3.75 17.25H8.25C8.44891 17.25 8.63968 17.171 8.78033 17.0303C8.92098 16.8897 9 16.6989 9 16.5C9 16.3011 8.92098 16.1103 8.78033 15.9697C8.63968 15.829 8.44891 15.75 8.25 15.75H6.75V14.1975C8.19901 14.0149 9.5317 13.3101 10.4982 12.2152C11.4647 11.1203 11.9987 9.71047 12 8.25Z" />
                    </svg>
            </button>`
                    : ''
            }
    
    ${
        validateAttachment
            ? `<button style="border: 1px solid " button-attachment id="ai-agent-id-attachment-${idAgent}" class="button-attachment "
                    style="outline: none; border: none; background: none">
                    <svg width="14" height="20" fill="${config.iconSendColor}" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 280.07 280.07" xml:space="preserve"  transform="rotate(270)matrix(1, 0, 0, -1, 0, 0)"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path d="M149.823,257.142c-31.398,30.698-81.882,30.576-113.105-0.429 c-31.214-30.987-31.337-81.129-0.42-112.308l-0.026-0.018L149.841,31.615l14.203-14.098c23.522-23.356,61.65-23.356,85.172,0 s23.522,61.221,0,84.586l-125.19,123.02l-0.044-0.035c-15.428,14.771-40.018,14.666-55.262-0.394 c-15.244-15.069-15.34-39.361-0.394-54.588l-0.044-0.053l13.94-13.756l69.701-68.843l13.931,13.774l-83.632,82.599 c-7.701,7.596-7.701,19.926,0,27.53s20.188,7.604,27.88,0L235.02,87.987l-0.035-0.026l0.473-0.403 c15.682-15.568,15.682-40.823,0-56.39s-41.094-15.568-56.776,0l-0.42,0.473l-0.026-0.018l-14.194,14.089L50.466,158.485 c-23.522,23.356-23.522,61.221,0,84.577s61.659,23.356,85.163,0l99.375-98.675l14.194-14.089l14.194,14.089l-14.194,14.098 l-99.357,98.675C149.841,257.159,149.823,257.142,149.823,257.142z"></path> </g> </g></svg>
            </button>`
            : ''
    }
            <button  id="ai-agent-id-send-submit" class="button-send"
                    style="outline: none; border: none; background: none">
                    <svg fill="${config.iconSendColor}" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                    <path id="send" d="M14.2549 5.98997L3.75494 0.739974C3.34056 0.533731 2.87265 0.460307 2.41502 0.529713C1.95738 0.599119 1.53229 0.807977 1.19769 1.12781C0.863094 1.44765 0.635281 1.86289 0.545311 2.31693C0.455341 2.77097 0.507592 3.24171 0.694941 3.66497L2.49494 7.69247C2.53578 7.78985 2.55682 7.89438 2.55682 7.99997C2.55682 8.10557 2.53578 8.2101 2.49494 8.30747L0.694941 12.335C0.542467 12.6775 0.478008 13.0527 0.507424 13.4265C0.53684 13.8003 0.659198 14.1608 0.863378 14.4753C1.06756 14.7897 1.34709 15.0482 1.67656 15.2271C2.00603 15.4061 2.375 15.4999 2.74994 15.5C3.10111 15.4965 3.44706 15.4145 3.76244 15.26L14.2624 10.01C14.6349 9.82261 14.948 9.53545 15.1667 9.18053C15.3855 8.82561 15.5013 8.41689 15.5013 7.99997C15.5013 7.58306 15.3855 7.17434 15.1667 6.81942C14.948 6.4645 14.6349 6.17734 14.2624 5.98997H14.2549ZM13.5874 8.66747L3.08744 13.9175C2.94956 13.9837 2.79474 14.0061 2.64373 13.9819C2.49272 13.9576 2.35275 13.8877 2.24258 13.7816C2.1324 13.6755 2.0573 13.5383 2.02734 13.3883C1.99738 13.2383 2.01399 13.0828 2.07494 12.9425L3.86744 8.91497C3.89065 8.86119 3.91068 8.8061 3.92744 8.74997H9.09494C9.29385 8.74997 9.48462 8.67096 9.62527 8.5303C9.76592 8.38965 9.84494 8.19889 9.84494 7.99997C9.84494 7.80106 9.76592 7.6103 9.62527 7.46964C9.48462 7.32899 9.29385 7.24997 9.09494 7.24997H3.92744C3.91068 7.19385 3.89065 7.13876 3.86744 7.08497L2.07494 3.05747C2.01399 2.9172 1.99738 2.76164 2.02734 2.61165C2.0573 2.46167 2.1324 2.32443 2.24258 2.21833C2.35275 2.11224 2.49272 2.04237 2.64373 2.01809C2.79474 1.9938 2.94956 2.01627 3.08744 2.08247L13.5874 7.33247C13.7103 7.39541 13.8134 7.49103 13.8854 7.60881C13.9574 7.72658 13.9955 7.86194 13.9955 7.99997C13.9955 8.13801 13.9574 8.27337 13.8854 8.39114C13.8134 8.50891 13.7103 8.60454 13.5874 8.66747Z"/>
                    </svg>
            </button>
            </div>
        </label>
    </form>
    </div>

    <div style="${session ? 'display:none; ' : ''}" class="ai-agent-form-body">
     <form id="form-session-${idAgent}">

     <div style="text-align: center; margin-top: 10px; margin-bottom: 35px; flex-direction: column" class="ai-agent-flex ai-agent-items-center">
      <img class="ai-agent-rounded-full" width="55px"
                              draggable="false"
                              src="${config.receiveIcon}" alt="">
       <p>
       ${config?.extra_config?.form_session?.welcome_title || ''}
         </p>
     </div>

      <div class="ai-agent-form-group">
         <label for="name-${idAgent}">${config?.extra_config?.form_session?.name?.label || ''}</label>
         <input required placeholder="${config?.extra_config?.form_session?.name?.placeholder || ''}" id="name-${idAgent}" autocomplete="off" class="ai-agent-form-control" type="text" name="name"/>
      </div>
      
        ${
            is_whatsapp
                ? `<div class="ai-agent-form-group">
            <label for="whatsapp-${idAgent}">${config?.extra_config?.form_session?.phone?.label || ''}</label>
           <div class="ai-agent-flex ai-agent-items-center ai-agent-gap-5">
           ${selectCountriesToBody()}
            <input placeholder="${config?.extra_config?.form_session?.phone?.placeholder || ''}" id="whatsapp-${idAgent}" required autocomplete="off" class="ai-agent-form-control" type="text" 
              pattern="\\(\\d{3}\\) \\d{3}-\\d{4}"
               maxlength="10" title="${config?.extra_config?.form_session?.phone?.title || ''}" name="phone" oninput="this.value = (()=> {
                const phoneNumber = this.value.replace(/\\D/g, '');
                return phoneNumber.replace(/(\\d{3})(\\d{3})(\\d{4})/, '($1) $2-$3'); 
            })()"/>
</div>
        </div>`
                : ''
        }

      <div style="display: none;" class="ai-agent-form-group">
         <label for="name-${idAgent}">${config?.extra_config?.form_session?.email?.label || ''}</label>
         <input  placeholder="${config?.extra_config?.form_session?.email?.placeholder || ''}" id="email-${idAgent}" autocomplete="off" class="ai-agent-form-control" type="email" name="email"/>
      </div>

      

      <div class="ai-agent-form-group ai-agent-flex ai-agent-items-center">
          <input required id="ai-agent-accept-${idAgent}" style="margin-right: 10px; " type="checkbox"/> <a target="_blank" class="ai-agent-link" href="${config.privacyPolicy}">${config?.extra_config?.form_session?.privacy_policy_message || ''}</a>
      </div>

      <span style="margin-bottom: 40px"><br></span>

      <div class="ai-agent-form-group">
          <button class="ai-agent-session-submit" type="submit">${config?.extra_config?.form_session?.init_chat_message || ''}</button>
      </div>

     </form>
    </div>

    <small style="padding: 6px; font-size: 10px; color: black; font-weight: bold" class="ai-agent-flex ai-agent-justify-center ai-agent-items-center">
        <a href="https://sbx360.com" class="ai-agent-justify-center ai-agent-items-center" style="color: black; text-decoration: none; font-weight: bold; display: flex;">
            Powered by <img width="55px" style="margin-left: 10px" src="data:image/png;base64,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
" alt="SBX360 - AI-Powered Customer Experience Platform">
        </a>
    </small>
</div>

<span id="ai-agent-icon-id-open-${idAgent}" class="crm-ai-agent-icon crm-ai-agent-icon-open">
        ${config?.extra_config?.text_bubble ? textBubbleHtml : ''}
         <img draggable="false" src="${config.receiveIcon}" alt="">
         <span class="toggle-bot-content">
         <svg fill="white" width="15px" height="15px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>times</title> <path d="M17.769 16l9.016-9.016c0.226-0.226 0.366-0.539 0.366-0.884 0-0.691-0.56-1.251-1.251-1.251-0.346 0-0.658 0.14-0.885 0.367v0l-9.015 9.015-9.016-9.015c-0.226-0.226-0.539-0.366-0.884-0.366-0.69 0-1.25 0.56-1.25 1.25 0 0.345 0.14 0.658 0.366 0.884v0l9.015 9.016-9.015 9.015c-0.227 0.226-0.367 0.539-0.367 0.885 0 0.691 0.56 1.251 1.251 1.251 0.345 0 0.658-0.14 0.884-0.366v0l9.016-9.016 9.015 9.016c0.227 0.228 0.541 0.369 0.888 0.369 0.691 0 1.251-0.56 1.251-1.251 0-0.347-0.141-0.661-0.369-0.887l-0-0z"></path> </g></svg>
</span>
</span>
`;
}

function addMessageToBody(message) {
    const doc = document.getElementById(idAgent);
    if (doc) {
        const aiAgentChatBody = doc?.querySelector('.ai-agent-chat-body');
        const pOnBody = aiAgentChatBody.querySelector('p');
        if (pOnBody) pOnBody.remove();
        const aiAgentData = document.createElement('div');
        aiAgentData.classList.add('ai-agent-data');
        aiAgentData.innerHTML = message;
        aiAgentChatBody.appendChild(aiAgentData);
        aiAgentChatBody.scrollTop = aiAgentChatBody.scrollHeight;
    }
}

function removeIfExistWaiting() {
    const waitDiv = document.getElementById(`ai-agent-waiting-message-${idAgent}`);
    if (waitDiv) waitDiv.style.opacity = '0';
}

function setMessage(state) {
    let formatMessage;

    if (state.author === session.author) {
        formatMessage = messageToSendBodyHtml(
            '',
            config.sendIcon,
            state,
            new Date(state.dateUpdated).toLocaleTimeString()
        );

        addMessageToBody(formatMessage);
    } else {
        if (state.author === 'VirtualAgent' || state.author === 'botv2') {
            formatMessage = messageToReceiveBodyHtml(
                '',
                config.receiveIcon,
                state,
                new Date(state.dateUpdated).toLocaleTimeString()
            );
        } else if (state.author === data.look_and_feel_chat.agent_name) {
            formatMessage = messageToReceiveBodyHtml(
                '',
                state.icon || config.receiveIcon,
                state,
                new Date(state.dateUpdated).toLocaleTimeString()
            );
        } else {
            formatMessage = messageToReceiveBodyHtml(
                '',
                state.icon || config.receiveIcon,
                state,
                new Date(state.dateUpdated).toLocaleTimeString(),
                undefined,
                data,
                true
            );
            //actionAssessorClick(false);
        }
        removeIfExistWaiting();
        addMessageToBody(formatMessage);
    }
}

function loadMessages(messages) {
    if (with_initial_message) {
        const input = document?.querySelector('#ai-agent-input-message');
        const initialMessage = input.value || config.extra_config?.initial_message || '';
        if (!messages.length) {
            loadingBot();
            conversation.sendMessage(initialMessage);
            input.value = '';
        }
        messages.forEach(setMessage);
    }
}

function botEventService(evt, type) {
    try {
        const event = new CustomEvent('onBotService', {
            detail: {
                info: evt,
                type,
                agentId: idAgent,
                session,
                sessionKey,
            },
        });

        window.dispatchEvent(event);
    } catch (e) {
        console.error(e);
    }
}

async function initConversation() {
    if (conversation && config) {
        const current_messages = await conversation.getMessages();

        if (data) {
            const messages = current_messages.items.map((item) => item.state.body);

            //suggestion filtered
            const doc = document.getElementById(idAgent);
            const suggestionContent = doc?.querySelector('.ai-agent-suggestion-content');
            suggestionContent?.querySelector('small')?.remove();
            const bodyChat = doc?.querySelector('.ai-agent-chat-body');
            const suggestions = config.suggestedMessage;
            if (suggestions.length) {
                const filterSuggestions = suggestions.filter(
                    (item) => !messages.some((message) => message.includes(item))
                );
                filterSuggestions.forEach((suggestion) => {
                    const suggestionItem = formatSuggestionItem(suggestion);
                    suggestionContent?.insertAdjacentHTML('beforeend', suggestionItem);
                });

                if (bodyChat) {
                    if (session?.isAssessor) bodyChat.style.height = '374px';
                    else bodyChat.style.height = '320px';
                }
            } else {
                suggestionContent.style.display = 'none';
                if (bodyChat) {
                    if (session?.isAssessor) bodyChat.style.height = '420px';
                    else bodyChat.style.height = '374px';
                }
                // if(bodyChat) bodyChat.style.height = '354px';
            }

            // role options filtered
            // const roleOptionContent = document?.querySelectorAll(`button[role-button="${idAgent}"]`);
        }

        loadMessages(current_messages.items);
        conversation.on('messageAdded', (message) => {
            if (['chat', 'finalizado'].every((item) => message.state.body?.toLowerCase().includes(item))) {
                finalizeChat();
            } else {
                setMessage(message);
                botEventService({ message }, 'newMessageReceived');
            }
        });
    }
}

function onStartTwilioConversation() {
    if (client) {
        client.shutdown();
        client = null;
    }

    client = new Twilio.Conversations.Client(session.token);

    client.on('conversationJoined', async (c) => {
        if (c.sid === session?.sid) {
            console.log('Conversation joined:', c.sid);
            conversation = c;
            initConversation();
            hideRoleContent(false);
        }
    });
    client.on('conversationAdded', (c) => {
        if (c.sid === session?.sid) {
            console.log('Conversation added:', c.sid);
        }
    });

    client.on('conversationRemoved', (c) => {
        if (c.sid === session?.sid) {
            console.log('Conversation removed:', c.sid);
            finalizeChat();
        }
    });
}

function formatSuggestionItem(message) {
    return `
     <span ai-agent-suggestion-attr="true" class="ai-agent-suggestion-item">
            <small style="font-size: 10px; color: gray">${message}</small>
        </span>
    `;
}

function getDownloadImage(color, size = '25px') {
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="${size}" height="${size}"><line x1="32" y1="12" x2="32" y2="40" stroke="${color}" stroke-width="4" stroke-linecap="round"/><polyline points="20,32 32,44 44,32" fill="none" stroke="${color}" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/><line x1="16" y1="52" x2="48" y2="52" stroke="${color}" stroke-width="4" stroke-linecap="round"/></svg>`;
}

function getPdfImage(isSend, size = '22px') {
    return `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 24 24" fill="${isSend ? '#4285f4' : '#fff'}"><path d="M14 2H6a2 2 0 0 0-2 2v16c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V8z"/><polyline fill="${isSend ? '#fff' : '#4285f4'}" points="14 2 14 8 20 8"/><rect x="8" y="13" width="8" height="1.5" fill="${isSend ? '#fff' : '#4285f4'}" rx=".5"/><rect x="8" y="16" width="8" height="1.5" fill="${isSend ? '#fff' : '#4285f4'}" rx=".5"/><rect x="8" y="10" width="5" height="1.5" fill="${isSend ? '#fff' : '#4285f4'}" rx=".5"/></svg>`;
}

function getEyeImage(color, size = '17px') {
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${size}" height="${size}" fill="none" stroke="${color}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8S1 12 1 12z"/><circle cx="12" cy="12" r="3"/></svg>`;
}

function stateMessage(state, randomId, isSend = true) {
    const excelImg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="25px" height="25px"><rect width="48" height="48" rx="8" fill="#217346"/><rect x="10" y="10" width="28" height="28" rx="2" fill="#fff"/><path d="M16 16h16v16H16z" fill="#21a366"/><path d="M20 20l4 4-4 4h2l2-2 2 2h2l-4-4 4-4h-2l-2 2-2-2h-2z" fill="#fff"/></svg>`;

    const textImg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="25px" height="25px"><rect x="12" y="8" width="40" height="48" rx="4" fill="#fff" stroke="#ccc" stroke-width="2"/><rect x="12" y="8" width="40" height="6" fill="#4A90E2"/><line x1="16" y1="20" x2="48" y2="20" stroke="#bbb" stroke-width="2"/><line x1="16" y1="28" x2="48" y2="28" stroke="#bbb" stroke-width="2"/><line x1="16" y1="36" x2="48" y2="36" stroke="#bbb" stroke-width="2"/><line x1="16" y1="44" x2="48" y2="44" stroke="#bbb" stroke-width="2"/><line x1="16" y1="52" x2="48" y2="52" stroke="#bbb" stroke-width="2"/></svg>`;

    const wordImg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="25px" height="25px"><rect width="48" height="48" rx="8" fill="#2B579A"/><rect x="12" y="10" width="24" height="28" rx="2" fill="#fff"/><rect x="12" y="10" width="6" height="28" fill="#fff"/><text x="24" y="33" font-size="18" font-family="Arial, sans-serif" fill="#2B579A" text-anchor="middle" font-weight="bold">W</text></svg>`;

    const csvImg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="25px" height="30px"><rect x="0" y="0" width="64" height="64" rx="10" fill="#3D9A50"/><rect x="14" y="8" width="36" height="40" rx="2" fill="#fff"/><rect x="14" y="8" width="36" height="6" fill="#2D7A3A"/><line x1="18" y1="20" x2="46" y2="20" stroke="#ccc" stroke-width="2"/><line x1="18" y1="26" x2="46" y2="26" stroke="#ccc" stroke-width="2"/><line x1="18" y1="32" x2="46" y2="32" stroke="#ccc" stroke-width="2"/><line x1="18" y1="38" x2="46" y2="38" stroke="#ccc" stroke-width="2"/><text x="32" y="58" font-size="10" font-family="Arial, sans-serif" fill="#fff" text-anchor="middle" font-weight="bold">CSV</text></svg>`;

    const loadingSvg = `<svg style="width:34px;height:34px;" fill="hsl(228, 97%, 42%)" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><circle cx="4" cy="12" r="3" opacity="1"><animate id="spinner_qYjJ" begin="0;spinner_t4KZ.end-0.25s" attributeName="opacity" dur="0.75s" values="1;.2" fill="freeze"/></circle><circle cx="12" cy="12" r="3" opacity=".4"><animate begin="spinner_qYjJ.begin+0.15s" attributeName="opacity" dur="0.75s" values="1;.2" fill="freeze"/></circle><circle cx="20" cy="12" r="3" opacity=".3"><animate id="spinner_t4KZ" begin="spinner_qYjJ.begin+0.3s" attributeName="opacity" dur="0.75s" values="1;.2" fill="freeze"/></circle></svg>`;

    const className = isSend ? 'ai-agent-link' : 'ai-agent-link-receive';
    const style = isSend ? 'color:black!important;' : 'color:white!important;';

    async function generateURL() {
        const categorizedMedia = await state.getMediaByCategory(['media']);
        return await categorizedMedia[0].getContentTemporaryUrl();
    }

    switch (state.type) {
        case 'media':
            generateURL().then((url) => {
                const contentType = state?.media?.state?.contentType;
                const moreText = ['image/', 'pdf'].some((item) => contentType.includes(item)) ? 20 : 10;
                const filename = state?.media?.state?.filename?.substring(0, moreText) || 'file';
                const docMessage = document.getElementById(randomId.toString());
                switch (!!docMessage) {
                    case contentType.includes('image/'):
                        docMessage.innerHTML = `
                        <div style="position: relative">
                            <a href="${url}" target="_blank" style="">
                                <img alt="Image to loaded from bot." src="${url}" style="width: 200px; height: 150px; object-fit: cover; border-radius: 6px;">
                            </a>
                            <div style="display: flex;align-items: center;justify-content: space-between; margin-top: 10px;">
                                <a style="margin-left: 6px;text-overflow: ellipsis;white-space: nowrap;overflow:hidden;${style}" href="${url}" target="_blank" class="${className}">${filename}</a>
                                <div style="display: flex;align-items: center;gap: 5px;">
                                    <a href="${url}" target="_blank" style="">
                                        ${getEyeImage(isSend ? '#8F8F8F' : '#fff')}
                                    </a>
                                    <a href="${url}" download target="_blank" style="">
                                        ${getDownloadImage(isSend ? '#8F8F8F' : '#fff', '20px')}
                                    </a>
                                </div>
                            </div>
                        </div>
                        `;
                        break;

                    case contentType.includes('audio/'):
                        docMessage.innerHTML = `<audio controls src="${url}" style="width: 200px;">`;
                        break;
                    case contentType.includes('pdf'):
                        docMessage.innerHTML = `
                            <div style="position: relative">
                                <div onclick="window.open('${url}', '_blank')" style="width: 200px;height: 80px;overflow: hidden;border-radius: 6px;background: #fff;position: relative;cursor: pointer;">
                                    <iframe style="position: absolute;top: -65px;left: -60px;width: 320px;height: 240px;border: none;pointer-events: none;border-radius: 6px;" src="${url}#page=1&zoom=100" width="200px" height="150px"></iframe>
                                </div>
                                <div style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;">
                                    <div style="display: flex;align-items: center;">
                                        <div style="padding: 5px; display: flex; align-items: center; justify-content: center;border-radius: 6px;background: #E5F1FF;">
                                            ${getPdfImage(isSend)}
                                        </div>
                                        <a style="margin-left: 6px;text-overflow: ellipsis;white-space: nowrap;overflow:hidden;${style}" href="${url}" target="_blank" class="${className}">${filename}</a>
                                    </div>
                                    <div style="display: flex;align-items: center;gap: 5px;">
                                        <a href="${url}" target="_blank" style="">
                                            ${getEyeImage(isSend ? '#8F8F8F' : '#fff')}
                                        </a>
                                        <a href="${url}" download target="_blank" style="">
                                            ${getDownloadImage(isSend ? '#8F8F8F' : '#fff', '20px')}
                                        </a>
                                    </div>
                                </div>
                            </div>
                            `;
                        break;
                    case contentType.includes('spreadsheetml'):
                        docMessage.innerHTML = `
                            <div style="max-width: 105px; height: 27px; display: flex; align-items: center; justify-content: flex-end; gap: 5px;">
                                ${excelImg}
                                <a href="${url}" target="_blank" class="${className}">${filename}</a>
                            </div>`;
                        break;
                    case contentType.includes('csv'):
                        docMessage.innerHTML = `
                            <div style="max-width: 105px; height: 27px; display: flex; align-items: center; justify-content: flex-end; gap: 5px;">
                                ${csvImg}
                                <a href="${url}" target="_blank" class="${className}">${filename}</a>
                            </div>`;
                        break;
                    case contentType.includes('wordprocessingml'):
                        docMessage.innerHTML = `
                            <div style="max-width: 105px; height: 27px; display: flex; align-items: center; justify-content: flex-end; gap: 5px;">
                                ${wordImg}
                                <a href="${url}" target="_blank" class="${className}">${filename}</a>
                            </div>`;
                        break;
                    case contentType.includes('text'):
                        docMessage.innerHTML = `
                            <div style="max-width: 105px; height: 27px; display: flex; align-items: center; justify-content: flex-end; gap: 5px;">
                                ${textImg}
                                <a href="${url}" target="_blank" download class="${className}">${filename}</a>
                            </div>`;
                        break;
                }
            });

            return `<div style="max-width: 105px; height: 27px; display: flex; align-items: center; justify-content: flex-start; gap: 2px;">
                                ${loadingSvg}
                                <span style="font-size: 10px; color: gray; text-align: center;">${config?.extra_config?.loading_message_file || 'Loading...'}</span>
                            </div>`;

        case 'text':
            if (isSend) {
                return formatMarkdown(state.body);
            }
            return '';
    }
}

function messageToSendBodyHtml(label, imageMe, state, time) {
    const randomId = Math.floor(Math.random() * 1000000 + 10000000);

    return `
                    <div id="${randomId}" class="ai-agent-data-right">
                        ${stateMessage(state, randomId)}
                    </div>
                    <small class="ai-agent-time-right">
                        ${time}
                    </small>
                `;
}

function messageFormat(message) {
    const temporallyId = Math.floor(Math.random() * 1000000 + 10000000).toString();

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    function messageWithSourceModel(msg) {
        //source_model_4e60d1ab-84bc-49ea-ad28-1a89544eaeb9
        //source_model_8 digits-4 digits-4 digits-4 digits-12 digits)
        const regExp = /source_model_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/;

        const key = msg.match(regExp)[0];
        const [, ...arrayFormat] = msg.split(regExp);
        const keyValue = key.replace('source_model_', '');

        //array of data
        let data = [];

        try {
            data = JSON.parse(arrayFormat.join(' ').replaceAll('```', '').replaceAll(`'''`, '').replace('json', ''));
        } catch (error) {
            console.error(error);
        }

        new Promise(async (resolve) => {
            const template = await getTemplateComponentByKeyService(keyValue);
            resolve(template.item);
        }).then((component) => {
            const doc = document.getElementById(temporallyId);
            if (doc) {
                doc.innerHTML = `<style> ${component.css}</style> ${component.html}`;
                const elementList = doc.querySelectorAll('div[cms-agent-list]');
                for (const element of elementList) {
                    const child = element.querySelector('div[cms-agent-body]');

                    if (child) {
                        element.removeChild(child);
                        data.forEach((item) => {
                            const clone = child.cloneNode(true);
                            const images = clone.querySelectorAll('img[src]');
                            for (const image of images) {
                                const key = image.getAttribute('cms-src');
                                if (key.includes('item.')) {
                                    const value = key.replace('item.', '');
                                    image.src = item[value];
                                }
                            }
                            const variables = clone.querySelectorAll('span[cms-field-var]');
                            for (const variable of variables) {
                                const key = variable.getAttribute('cms-field-var');
                                const value = key ? item[key] : '';
                                if (value) variable.innerHTML = value;
                            }

                            const aref = clone.querySelectorAll('a');
                            for (const a of aref) {
                                const href = a.getAttribute('href');
                                if (href.includes('${item.')) {
                                    // format regexp ${item.[a-zA-Z]+}
                                    const keys = href.match(/\${item.([a-zA-Z]+)}/g);
                                    keys.forEach((key) => {
                                        const value = key.replace('${item.', '').replace('}', '');
                                        a.href = href.replace(key, item[value]);
                                    });
                                }
                            }
                            element.appendChild(clone);
                        });
                    }
                }
            }
        });
    }

    const foundSkillWithTemplate = data?.with_template;

    switch (true) {
        case !!message?.includes('source_model'):
            messageWithSourceModel(message);
            message = `<div id="${temporallyId}" style="width: 100%">
                       <div class="agent-loader">
                         <span></span>
                         <span></span>
                         <span></span>
                       </div>
                   </div>`;

            break;

        case !message.includes('source_model_') && message.includes('json') && !foundSkillWithTemplate:
            try {
                const formatJson = message.replaceAll('```', '').replaceAll(`'''`, '').split('json')[1];

                const data = JSON.parse(formatJson);
                message = `<div style="padding: 2px;">
                    ${data
                        .map((data) => {
                            const headers = Object.keys(data);

                            return `
                        <ul style="list-style: none; padding: 0;">
                            ${headers
                                .map((header) => {
                                    return `
                            <li style="padding: 5px;">
                                <b>${header}</b><br> ${(() => {
                                    const value = data[header];
                                    switch (true) {
                                        case typeof value === 'object':
                                            return JSON.stringify(value);
                                        case typeof value === 'boolean':
                                            return value ? 'Yes' : 'No';

                                        case value.endsWith('.jpg') ||
                                            value.endsWith('.png') ||
                                            value.endsWith('.jpeg'):
                                            return `<img  alt="" src="${value}" style="width: 100px; height: 100px; border-radius: 5px">`;
                                        default:
                                            return value;
                                    }
                                })()}
                            </li>
                            `;
                                })
                                .join('')}
                        `;
                        })
                        .join('')}
                    </div>`.replaceAll('\n', '');
            } catch (e) {
                console.log(e);
            }

            break;

        case !!foundSkillWithTemplate && message.includes('json'):
            console.log(foundSkillWithTemplate);
            break;
    }
    return formatMarkdown(message);
}

function messageToReceiveBodyHtml(label, imageMe, state, time, waiting, data, isAsessor = false) {
    const { images = [] } = data ?? {};
    const randomId = Math.floor(Math.random() * 1000000 + 10000000);
    playSound?.();
    const message = stateMessage(state, randomId, false);

    return `
                    <div class="ai-agent-flex">
                      <div aria-waiting="${waiting ? 'true' : 'false'}" class="ai-agent-flex  ai-agent-responsible-left">
                        ${
                            isAsessor
                                ? `
                            <div class="ai-agent-rounded-full ai-agent-assessor-bubble"> 
                             ${state.author?.slice(0, 2)?.toUpperCase() || 'A'}
                            </div>
                            `
                                : `
                            <img class="ai-agent-rounded-full"
                              draggable="false"
                              width="30px"
                              height="30px"
                              src="${imageMe}" alt=""></img>
                            
                            `
                        }
                      </div>
                      <div id="${randomId}" style="word-wrap: break-word" class="ai-agent-data-left ${waiting ? 'ai-agent-waiting' : 'ai-agent-response'}">
                          ${state.body ? messageFormat(state.body) : ''}
                          ${message}
                          ${(() => {
                              if (images?.length) {
                                  return `
                                  <br/>
                                  ${images
                                      .map((image) => {
                                          return `<img image-clicked alt="" src="${image}" style="width: 100%; border-radius: 5px; cursor: pointer;">`;
                                      })
                                      .join('')}
                                  
                                  `;
                              }

                              return '';
                          })()}
                      </div>
                    </div>
                    <small class="ai-agent-time-left">
                        ${time}
                    </small>
                `;
}

function openCloseChat(open) {
    const doc = document.getElementById(idAgent);
    const roleOptionContent = document?.getElementById(`role-${idAgent}`);
    doc?.setAttribute('aria-open', open ? 'true' : 'false');
    roleOptionContent?.setAttribute('aria-open', open ? 'false' : 'true');

    if (open) {
        const textEl = document.getElementById('chat-bot-message-ui');
        if (textEl) {
            setTimeout(() => textEl.remove(), 500);
        }
    }
    botEventService(
        {
            open,
        },
        'openCloseChat'
    );
}

function findParent(elem, keyParent) {
    let parent = elem;

    while (parent && !parent?.hasAttribute?.(keyParent)) {
        parent = parent.parentElement;
    }

    if (parent?.hasAttribute?.(keyParent)) {
        return parent;
    }

    return null;
}

function selectCountriesToBody() {
    setTimeout(() => {
        const select = document.getElementById(`country-select-${idAgent}`);
        const selected = select.querySelector('.selected-agent');
        const optionsContainer = select.querySelector('.options-agent');
        const optionsList = optionsContainer.querySelectorAll('.option-agent');

        selected.addEventListener('click', () => {
            select.classList.toggle('open');
        });

        optionsList.forEach((option) => {
            option.addEventListener('click', () => {
                selected.innerHTML = `<span>${option.innerHTML}</span> ▼`;
                select.classList.remove('open');
                const countryValueAgent = document.getElementById(`country-select-${idAgent}-hidden`);
                if (countryValueAgent) countryValueAgent.value = option.dataset.value;
            });
        });

        document.addEventListener('click', (e) => {
            if (!select.contains(e.target)) {
                select.classList.remove('open');
            }
        });
    }, 1000);

    const default_country = countries.find((country) => country.code === defaultCountry) || {};
    return `
        <div class="custom-select-agent" id="country-select-${idAgent}">
            <div class="selected-agent">
                <span>
                  <img alt="s" src="https://flagcdn.com/w20/${default_country.country?.toLowerCase()}.png">${default_country?.code}
                </span>
               <svg width="14px" height="14px" class="agent-caret-down" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M7.00003 8.5C6.59557 8.5 6.23093 8.74364 6.07615 9.11732C5.92137 9.49099 6.00692 9.92111 6.29292 10.2071L11.2929 15.2071C11.6834 15.5976 12.3166 15.5976 12.7071 15.2071L17.7071 10.2071C17.9931 9.92111 18.0787 9.49099 17.9239 9.11732C17.7691 8.74364 17.4045 8.5 17 8.5H7.00003Z" fill="#000000"></path> </g></svg>
            </div>
            <div class="options-agent">
                ${countries
                    .map((country) => {
                        return `<div class="option-agent" data-value="${country.code}">
                <img src="https://flagcdn.com/w20/${country?.country?.toLowerCase()}.png" width="20px">
                <span>${country.code}</span>
                </div>`;
                    })
                    .join('')}
            </div>
        </div>

        <input type="hidden" name="country" id="country-select-${idAgent}-hidden" value="${default_country.code || ''}" />
    `;
}

function loadingBot() {
    if (!session.isAssessor) {
        const waitDiv = document.getElementById(`ai-agent-waiting-message-${idAgent}`);
        if (waitDiv) waitDiv.style.opacity = '1';
    }
}

async function onSubmitData(evt, isMedia = false, file = null, isAttachment = false) {
    evt.preventDefault();

    switch (true) {
        case isMedia && !!file:
            const response = await fetch(URL.createObjectURL(file));
            const fileBlob = await response.blob();

            const mediaFormData = new FormData();
            mediaFormData.set('twilio-audio', fileBlob, 'twilio-audio.mp3');

            const sendMediaOptions = {
                contentType: response.headers.get('Content-Type'),
                filename: 'twilio-audio',
                media: fileBlob,
            };
            botEventService(
                {
                    mediaFormData,
                },
                'newRecordAudioMessage'
            );

            await conversation
                .prepareMessage()
                .setBody('audio!')
                .addMedia(mediaFormData)
                .addMedia(sendMediaOptions)
                .build()
                .send();

            loadingBot();
            break;

        case isAttachment && !!file:
            const responseImage = await fetch(URL.createObjectURL(file));
            const fileBlobImage = await responseImage.blob();

            const attachmentFormData = new FormData();
            attachmentFormData.set(`twilio-file`, file, file.filename);

            const sendAttachmentOptions = {
                contentType: responseImage.headers.get('Content-Type'),
                filename: file.filename,
                media: fileBlobImage,
            };

            botEventService(
                {
                    attachmentFormData,
                },
                'newAttachmentMessage'
            );

            const idLoading = `ai-agent-loading-${idAgent}`;
            alertNativeBot(config?.extra_config?.loading_message_file || 'Loading...', 'waiting', idLoading);

            await conversation
                .prepareMessage()
                .setBody('attachment!')
                .addMedia(attachmentFormData)
                .addMedia(sendAttachmentOptions)
                .build()
                .send();
            alertNativeBot(
                config?.extra_config?.loaded_message_file || 'Loaded!',
                'success',
                'success-alert',
                idLoading
            );

            break;

        default:
            const doc = document.getElementById(idAgent);
            const inputMessage = doc?.querySelector('#ai-agent-input-message');
            const message = inputMessage?.value;

            botEventService(
                {
                    message,
                },
                'newMessageSent'
            );

            if (message) {
                await conversation.sendMessage(message);
                inputMessage.value = '';
                loadingBot();
            }
            break;
    }
}

async function actionAssessorClick(sendMessage = true) {
    const doc = document.getElementById(idAgent);
    trackEvent('sbx_crm_omnichannel_web_request_agent_click');

    const agentAction = doc?.querySelector(`#ai-agent-assessor-action-${idAgent}`);
    agentAction.style.display = 'none';
    if (sendMessage) conversation.sendMessage(config?.extra_config?.call_agent_message || 'agent');

    const newSession = {
        ...session,
        isAssessor: true,
    };
    session = newSession;
    closeRoleContent();
    localStorage.setItem(sessionKey, JSON.stringify(newSession));
    const divWaitingAndAssessor = document.getElementById(`ai-agent-waiting-and-assessor-${idAgent}`);
    const suggestionContent = doc?.querySelector('.ai-agent-suggestion-content');
    const bodyChat = doc?.querySelector('.ai-agent-chat-body');
    if (divWaitingAndAssessor) divWaitingAndAssessor.style.display = 'none';
    if (suggestionContent?.style.display === 'none') {
        if (bodyChat) bodyChat.style.height = '420px';
    } else {
        if (bodyChat) bodyChat.style.height = '374px';
    }
}

async function actionMicrophoneMouseDown(evt) {
    evt.preventDefault();

    const parentEvt = findParent(evt.target, 'button-microphone');
    parentEvt?.classList.add('button-microphone-active');
    recorder = null;
    navigator.mediaDevices
        .getUserMedia({ audio: true })
        .then((stream) => {
            // store streaming data chunks in array
            const chunks = [];
            // create media recorder instance to initialize recording
            recorder = new MediaRecorder(stream);
            // function to be called when data is received
            recorder.ondataavailable = async (e) => {
                // add stream data to chunks
                chunks.push(e.data);
                // if recorder is 'inactive' then recording has finished
                if (recorder.state === 'inactive') {
                    // convert stream data chunks to a 'webm or mpeg-3' audio format as a blob
                    const blob = new Blob(chunks, { type: 'audio/mpeg-3' });
                    // convert blob to URL so it can be assigned to a audio src attribute

                    parentEvt?.classList.remove('button-microphone-active');
                    recorder = null;
                    await onSubmitData(evt, true, blob);
                }
            }; // start recording with 1 second time between receiving 'ondataavailable' events
            recorder.start(1000);
        })
        .catch(() => {
            if (recorder) {
                recorder.stop();
                // console.error('error recording audio => {}', e);
                recorder = null;
            }
        });
}

async function actionMicrophoneMouseUp(evt) {
    evt.preventDefault();
    setTimeout(() => {
        if (recorder) {
            recorder.stop();
        }
    }, 1000);
}

async function authenticationService(name, email = '', phone) {
    const fetchOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            name,
            email,
            phone,
            agent_id,
            version: versionBot,
            metadata: {
                origin: window.location.origin,
                params: Object.fromEntries(new URLSearchParams(window.location.search)),
                fullUrl: window.location.href,
                ...(locationData ?? {}),
                extra_metadata: extraMetadata ?? {},
            },
        }),
    };
    const response = await fetch(`${baseUrl}/api/v2/chat`, fetchOptions);
    return await response.json();
}

async function getTemplateComponentByKeyService(templateKey) {
    const fetchOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    };
    const response = await fetch(`${baseUrl}/api/data/v1/row/cms_component/${templateKey}`, fetchOptions);
    return await response.json();
}

function loginListenerFromParent() {
    window.addEventListener('onLoginBot', (e) => {
        const { type } = e.detail;

        switch (type) {
            case 'login':
                const { phone, name, email, countryCode, metadata } = e.detail;
                extraMetadata = metadata;
                const doc = document.getElementById(idAgent);
                const nameElem = doc?.querySelector(`#name-${idAgent}`);
                const emailElem = doc?.querySelector(`#email-${idAgent}`);
                const whatsappElem = doc?.querySelector(`#whatsapp-${idAgent}`);
                const countryDiv = doc?.querySelector(`#country-select-${idAgent}`);
                const countryElem = doc?.querySelector(`#country-select-${idAgent}-hidden`);
                const acceptElem = doc?.querySelector(`#ai-agent-accept-${idAgent}`);
                if (nameElem) nameElem.value = name;
                if (emailElem) emailElem.value = email;
                if (acceptElem) acceptElem.checked = true;
                if (whatsappElem) whatsappElem.value = phone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
                if (countryDiv) {
                    const codeContent = document.querySelector(`div[data-value="${countryCode}"]`);
                    if (codeContent) {
                        const select = document.getElementById(`country-select-${idAgent}`);
                        const selected = select.querySelector('.selected-agent');
                        selected.innerHTML = `<span>${codeContent.innerHTML}</span> ▼`;
                    }
                }
                if (countryElem) countryElem.value = countryCode;
                trackEvent('sbx_crm_omnichannel_web_start_chat');
                const form = doc?.querySelector(`#form-session-${idAgent}`);
                if (form) {
                    //const button = form.querySelector('.ai-agent-session-submit');
                    //button.click();
                }

                break;
            case 'logout':
                if (conversation) {
                    conversation.sendMessage('salir');
                } else {
                    finalizeChat();
                }
                break;
        }
    });
}

async function onSubmitSession(evt) {
    evt.preventDefault();
    const doc = document.getElementById(idAgent);
    const nameElem = doc?.querySelector(`#name-${idAgent}`);
    const emailElem = doc?.querySelector(`#email-${idAgent}`);
    const whatsappElem = doc?.querySelector(`#whatsapp-${idAgent}`);
    const countryDiv = doc?.querySelector(`#country-select-${idAgent}`);
    const countryElem = doc?.querySelector(`#country-select-${idAgent}-hidden`);
    const button = doc?.querySelector('.ai-agent-session-submit');
    const accept = doc?.querySelector(`#ai-agent-accept-${idAgent}`);

    const name = nameElem?.value;
    const email = emailElem?.value;
    // replace (|)|- to string value
    const countryCode = countryElem?.value || '';
    const phone = countryCode + whatsappElem?.value.replace(/[()\-\s]/g, '');

    //disable inputs
    nameElem.disabled = true;
    emailElem.disabled = true;
    countryElem.disabled = true;
    if (whatsappElem) whatsappElem.disabled = true;
    if (countryDiv) countryDiv.classList.add('disabled');
    button.disabled = true;
    accept.disabled = true;

    if (name && (is_whatsapp ? phone : true)) {
        const responseStartChat = await authenticationService(name, email, phone);
        if (responseStartChat) {
            const _session = {
                ...responseStartChat,
                author: email || phone || name,
                name: name,
                phone,
                isAssessor: false,
                expiration: new Date(new Date().getTime() + 1000 * 60 * 60 * 24),
            };
            localStorage.setItem(sessionKey, JSON.stringify(_session));
            session = _session;
            onStartTwilioConversation();
            trackEvent('sbx_crm_omnichannel_web_start_chat');

            const formSession = doc?.querySelector('.ai-agent-form-body');
            formSession.style.display = 'none';
            const form = doc?.querySelector('.ai-agent-messages-body');
            form.style.display = 'block';

            //hide close icon and show options icon
            const closeIcon = doc?.querySelector(`#ai-agent-icon-id-close-${idAgent}`);
            closeIcon.style.display = 'none';
            const optionsIcon = doc?.querySelector(`#ai-agent-menu-options-action-${idAgent}`);
            optionsIcon.style.display = 'block';
        }
    }

    button.disabled = false;
    nameElem.disabled = false;
    emailElem.disabled = false;
    countryElem.disabled = false;
    if (whatsappElem) whatsappElem.disabled = false;
    if (countryDiv) countryDiv.classList.remove('disabled');
    accept.disabled = false;
}

async function finalizeChat() {
    //remove session from local storage
    localStorage.removeItem(sessionKey);
    const bot = document.getElementById('ai-chatbot');
    bot?.remove();
    session = null;
    conversation?.leave();
    trackEvent('sbx_crm_omnichannel_web_user_exit_chat');
    localStorage.removeItem('location_data_agent_script');
    botEventService({}, 'chatFinished');
    onStart();
}

function closeRoleContent() {
    const roleContent = document.getElementById(`role-${idAgent}`);
    if (roleContent) {
        roleContent.remove();
    }
}

function hideRoleContent(visibility) {
    const roleContent = document.getElementById(`role-${idAgent}`);
    roleContent?.setAttribute('bot-aria-hidden', visibility ? 'true' : 'false');
}

function initBot(data, config, elementStart) {
    elementStart.innerHTML = formatBot(config);
    // await new Promise((resolve) => setTimeout(resolve, 1000));

    const doc = document.getElementById(idAgent);
    const divWaitingAndAssessor = document.getElementById(`ai-agent-waiting-and-assessor-${idAgent}`);
    const bodyChat = doc?.querySelector('.ai-agent-chat-body');
    if (session?.isAssessor && divWaitingAndAssessor) {
        divWaitingAndAssessor.style.display = 'none';
        if (bodyChat) bodyChat.style.height = '374px';
    }
    const openAgent = document.querySelector(`#ai-agent-icon-id-open-${idAgent}`);
    openAgent?.addEventListener('click', () => {
        doc.getAttribute('aria-open') === 'true' ? openCloseChat(false) : openCloseChat(true);
    });

    const closeAgent = doc?.querySelector(`#ai-agent-icon-id-close-${idAgent}`);
    closeAgent?.addEventListener('click', () => openCloseChat(false));

    const closeAgentOption = doc?.querySelector(`#minimize-agent-action-${idAgent}`);
    closeAgentOption?.addEventListener('click', () => openCloseChat(false));

    const finalizeAgentOption = doc?.querySelector(`#finalize-agent-action-${idAgent}`);
    finalizeAgentOption?.addEventListener('click', () => {
        if (conversation) {
            conversation.sendMessage('salir');
        } else {
            finalizeChat();
        }
    });

    botEventService(
        {
            openCloseChat: openCloseChat,
            onFinishChat: finalizeChat,
            onAssessorRequest: actionAssessorClick,
        },
        'botStarted'
    );

    function sendMessageEvent(event) {
        const inputMessage = doc?.querySelector('#ai-agent-input-message');
        if (inputMessage) inputMessage.value = event.detail.message;

        if (session) {
            onSubmitData(
                {
                    preventDefault: () => {},
                },
                false,
                null,
                false
            ).then();
        }
    }

    window.addEventListener('botEvent', (event) => {
        switch (event.detail.type) {
            case 'sendMessage':
                sendMessageEvent(event);
                break;
        }
    });

    const popContentRoleAction = document.getElementById(`role-content-action-close-${idAgent}`);

    popContentRoleAction?.addEventListener('click', (e) => {
        e.stopPropagation();
        closeRoleContent();
    });

    const body = doc?.querySelector('.ai-agent-chat-body');

    const form = doc?.querySelector('#form-' + idAgent);

    const formSession = doc?.querySelector('#form-session-' + idAgent);
    formSession?.addEventListener('submit', onSubmitSession);

    const actionAssessor = doc?.querySelector(`#ai-agent-assessor-action-${idAgent}`);
    actionAssessor?.addEventListener('click', actionAssessorClick);

    const microphoneAction = doc?.querySelector(`#ai-agent-id-microphone-${idAgent}`);
    microphoneAction?.addEventListener('mousedown', actionMicrophoneMouseDown);
    microphoneAction?.addEventListener('mouseup', actionMicrophoneMouseUp);

    const actionAttachment = doc?.querySelector(`#ai-agent-id-attachment-${idAgent}`);
    actionAttachment?.addEventListener('click', (e) => {
        trackEvent('sbx_crm_omnichannel_web_attachment_click');
        if (e.pointerId === -1) return;
        const valueType = Object.entries(with_attachment).reduce((acc, [key, value]) => {
            if (value) {
                switch (key) {
                    case 'image':
                        acc.push('image');
                        break;
                    case 'pdf':
                        acc.push('pdf');
                        break;
                    case 'excel':
                        acc.push('xlsx');
                        break;
                    case 'word':
                        acc.push('docx');
                        break;
                    case 'csv':
                        acc.push('csv');
                        break;
                    default:
                        acc.push('text');
                        break;
                }
            }
            return acc;
        }, []);

        const input = document.createElement('input');
        input.type = 'file';
        input.value = '';
        input.accept = getFilesFormatToInput(valueType);
        input.multiple = false;
        input.click();
        input.onchange = async (e) => {
            const file = e.target.files[0];
            await onSubmitData(e, false, file, true);
            input.remove();
        };
    });

    form?.addEventListener('submit', (e) => onSubmitData(e));

    body.scrollTop = body.scrollHeight;

    // event from suggestions click
    document.addEventListener('click', (e) => {
        const parent = findParent(e.target, 'ai-agent-suggestion-attr');
        if (parent) {
            trackEvent('sbx_crm_omnichannel_web_suggestion_message_click');
            const suggestionContent = doc?.querySelector('.ai-agent-suggestion-content');
            const bodyChat = doc?.querySelector('.ai-agent-chat-body');
            const divWaitingAndAssessor = document.getElementById(`ai-agent-waiting-and-assessor-${idAgent}`);
            e.stopPropagation();
            parent.remove();
            const inputMessage = doc?.querySelector('#ai-agent-input-message');
            inputMessage.value = parent.textContent;
            onSubmitData(e);

            if (suggestionContent?.querySelectorAll('.ai-agent-suggestion-item').length === 0) {
                suggestionContent.style.display = 'none';
                if (divWaitingAndAssessor.style.display === 'none') {
                    if (bodyChat) bodyChat.style.height = '420px';
                } else {
                    if (bodyChat) bodyChat.style.height = '374px';
                }
            }
        }
    });

    //event clicking from the role button option
    const roleButton = document?.querySelectorAll(`button[role-button="${idAgent}"]`);

    roleButton.forEach((button) => {
        button.addEventListener('click', (e) => {
            e.stopPropagation();
            openCloseChat(true);

            setTimeout(() => {
                const role = button.textContent;
                sendMessageEvent({ detail: { message: role } });
            }, 100);
        });
    });

    if (session) {
        hideRoleContent(true);
        botEventService({}, 'callTwilioConversation');
        onStartTwilioConversation();
    }
}

async function startSessionForPreview() {
    const generateUniqueID = () => {
        return `${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
    };
    const unique = generateUniqueID();
    if (isPreview) {
        const res = await authenticationService(unique, `${unique}@gmail.test`, '99999999999');
        if (res) {
            const _session = {
                ...res,
                author: `${unique}@gmail.test`,
                name: unique,
                isAssessor: false,
                expiration: new Date(new Date().getTime() + 1000 * 60 * 60 * 24),
            };
            localStorage.setItem(sessionKey, JSON.stringify(_session));
            session = _session;
        }
    }
    return true;
}

async function validateSessionExpiration() {
    botEventService({}, 'validateSessionExpiration');

    if (session) {
        const { expiration = new Date() } = session;
        if (new Date(expiration) > new Date()) {
            // console.log('session recovered!');
        } else {
            // console.log('session expired!');
            localStorage.removeItem(sessionKey);
            session = null;
            return startSessionForPreview();
        }
    } else {
        return startSessionForPreview();
    }
}

function trackEvent(nameEvent) {
    const parser = new UAParser();
    const agent = {
        browser: parser.getBrowser(),
        device: parser.getDevice(),
        os: parser.getOS(),
        engine: parser.getEngine(),
    };

    const info = {
        props: {
            user: {
                name: session?.name || '',
                author: session?.author || '',
                phone: session?.phone || '',
            },
        },
        extra: {},
        meta: {
            extra: {
                trackCode: {
                    app: { name: data?.look_and_feel_chat?.agent_name || '', module: 'agent-script' },
                    user_agent: parser.getUA(),
                    user_agent_info: agent,
                    ...(locationData?.ip ? { ip: locationData?.ip } : {}),
                },
            },
            created: new Date(),
            name: nameEvent,
        },
    };

    const fetchOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(info),
    };

    fetch(`${baseUrl}/api/event`, fetchOptions).then();
}

function getFilesFormatToInput(files) {
    const accept2 = files.reduce((acc, val) => {
        val = val.toLowerCase();
        if (val.includes('image')) {
            acc += 'image/*,';
        } else if (val.includes('pdf')) {
            acc += '.pdf,';
        } else if (val.includes('audio')) {
            acc += 'audio/mpeg,';
        } else if (val.includes('docx')) {
            acc += 'application/vnd.openxmlformats-officedocument.wordprocessingml.document,';
        } else if (val.includes('xlsx')) {
            acc += 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,';
        } else if (val.includes('csv')) {
            acc += '.csv,';
        } else if (val.includes('text')) {
            acc += 'text/plain,';
        } else if (val.includes('video')) {
            acc += 'video/mp4,';
        }

        return acc;
    }, '');

    return accept2.substring(0, accept2.length - 1);
}

function formatMarkdown(text) {
    if (!text) return '';

    // Sanitize HTML entities
    text = text.replace(
        /[&<>"']/g,
        (m) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[m]
    );

    // **bold** o __bold__
    text = text.replace(/(\*\*|__)(.*?)\1/g, '<b>$2</b>');
    // *italic* o _italic_
    text = text.replace(/(\*|_)(.*?)\1/g, '<i>$2</i>');
    // ~~tachado~~
    text = text.replace(/~~(.*?)~~/g, '<s>$1</s>');
    // code
    text = text.replace(/`([^`]+)`/g, '<code>$1</code>');
    // [text](url)
    text = text.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, '<a href="$2" target="_blank">$1</a>');
    // break line -> <br>
    text = text.replace(/\n/g, '<br>');

    return text;
}

function replaceCodeWithEmojis(text) {
    const emojiMap = {
        ':wave:': '👋',
        ':smile:': '😄',
        ':heart:': '❤️',
        ':fire:': '🔥',
        ':check:': '✅',
    };

    if (!text) return '';
    return text.replace(/:\w+:/g, (match) => emojiMap[match] || match);
}

async function startBotContent() {
    const script = document.createElement('script');
    script.src = `https://unpkg.com/ua-parser-js@latest/dist/ua-parser.min.js`;
    document.head.appendChild(script);
    async function findConfigV1() {
        const fetchOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        };
        const response = await fetch(`${baseUrl}/api/ai_agent/agent/${agent_id}/bot`, fetchOptions);
        const data = (await response.json()).item;
        const config = {
            receiveIcon: data?.avatar || domainImagesUrl + 'images/bot_icon.png',
            sendIcon: 'https://icons.veryicon.com/png/o/miscellaneous/two-color-webpage-small-icon/user-244.png',
            title: replaceCodeWithEmojis(data?.title.replaceAll('[AgentName]', data.agent_name)),
            placeholder: 'Type your message...',
            receiveMessage: data?.agent_name,
            sendMessage: '',
            agentName: data?.agent_name,
            backgroundReceive: data?.background_agent_color || '#F6F6F6',
            backgroundSend: data?.background_user_color || '#FFFFFF',
            colorReceive: data?.text_agent_color || '#000000',
            colorSend: data?.text_user_color || '#000000',
            background: '#fff',
            timeColor: '#aaaaaa',
            inputFocus: '#0486e4',
            backgroundChat: '#f3f3f3',
            colorBorderInputTop: '#e8e8e8',
            colorBorderInputBottom: '#e8e8e8',
            iconSendColor: data?.button_color || '#0486e4',
            position: 'fixed',
            privacyPolicy: data?.privacy_policy_url || 'https://sbxcloud.com/#!/privacy',
            suggestedMessage: data?.suggested_message?.includes('[') ? JSON.parse(data.suggested_message) : [],
        };
        return { config, data };
    }

    async function findConfigV2() {
        const fetchOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        };
        const response = await fetch(`${baseUrl}/api/ai_agent_v2/agent/${agent_id}`, fetchOptions);
        const data = (await response.json()).item;
        const agentName = data?.look_and_feel_chat?.agent_name ?? '';
        const extra_config = JSON.parse(
            replaceCodeWithEmojis(data?.look_and_feel_chat?.extra_config?.replaceAll('[AgentName]', agentName) ?? '{}')
        );
        const config = {
            receiveIcon: data?.avatar || domainImagesUrl + 'images/bot_icon.png',
            sendIcon: 'https://icons.veryicon.com/png/o/miscellaneous/two-color-webpage-small-icon/user-244.png',
            title: data?.look_and_feel_chat.agent_name?.toUpperCase() || 'SBX 360',
            placeholder: extra_config?.search_placeholder || 'Type your message...',
            receiveMessage: data?.look_and_feel_chat?.agent_name ?? '',
            sendMessage: '',
            agentName,
            backgroundReceive: data?.look_and_feel_chat?.background_agent_color || '#F6F6F6',
            backgroundSend: data?.look_and_feel_chat?.background_user_color ?? '#FFFFFF',
            colorSend: data?.look_and_feel_chat?.text_user_color ?? '#000000',
            colorReceive: data?.look_and_feel_chat?.text_agent_color ?? '#000000',
            background: '#fff',
            timeColor: '#aaaaaa',
            inputFocus: '#3C8DFF',
            backgroundChat: '#f3f3f3',
            colorBorderInputTop: '#e8e8e8',
            colorBorderInputBottom: '#e8e8e8',
            iconSendColor: data?.look_and_feel_chat?.button_color || '#3C8DFF',
            position: 'fixed',
            privacyPolicy: data?.look_and_feel_chat?.privacy_policy_url ?? 'https://sbxcloud.com/#!/privacy',
            suggestedMessage: data?.look_and_feel_chat?.suggested_message ?? [],
            extra_config: {
                ...extra_config,
                roles_options: extra_config?.roles_options || [],
            },
        };
        return { config, data };
    }

    const service = versionBot !== 'v1' ? findConfigV2 : findConfigV1;

    const { config: _config, data: _data } = await service();

    config = _config;
    data = _data;

    if (!localStorage.getItem('location_data_agent_script')) {
        const resData = await fetch('https://ipapi.co/json/');
        locationData = await resData.json();
        localStorage.setItem('location_data_agent_script', JSON.stringify(locationData));
    } else {
        locationData = JSON.parse(localStorage.getItem('location_data_agent_script'));
    }

    const aiElement = document.createElement('div');
    aiElement.id = 'ai-chatbot';
    document.body.appendChild(aiElement);

    botEventService(
        {
            location: locationData,
            config: config,
            data: data,
        },
        'start'
    );

    initBot(data, config, aiElement);
}

function playSound() {
    try {
        const buttonPlayElem = document.getElementById(`button-play${idAgent}`);
        buttonPlayElem?.click?.();
    } catch (e) {
        console.error('error playing sound => {}', e);
    }
}

function alertNativeBot(message, type, id, idBefore) {
    if (idBefore) {
        const existingAlert = document.getElementById(idBefore);
        if (existingAlert) {
            existingAlert.remove();
        }
    }
    const alertDiv = document.createElement('div');
    alertDiv.id = id;
    alertDiv.innerHTML = `
    ${type === 'waiting' ? '' : '<svg width="25" height="25" fill="rgba(0,0,0,0.6)" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>'}
    <div style="font-size: 16px;">${message}</div>
  `;

    Object.assign(alertDiv.style, {
        position: 'fixed',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        bottom: '20px',
        left: '20px',
        padding: '15px 20px',
        backgroundColor: type === 'waiting' ? 'rgba(255,151,0,0.9)' : 'rgba(166,239,184,0.9)',
        color: 'rgba(0,0,0,0.6)',
        borderRadius: '8px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
        zIndex: '9999',
        fontFamily: 'sans-serif',
        opacity: '0',
        transition: 'opacity 0.5s ease',
    });

    document.body.appendChild(alertDiv);

    requestAnimationFrame(() => {
        alertDiv.style.opacity = '1';
    });

    if (type !== 'waiting') {
        setTimeout(() => {
            alertDiv.style.opacity = '0';
            alertDiv.addEventListener('transitionend', () => {
                alertDiv.remove();
            });
        }, 3000);
    }
}

/*
 *
 * @params {
 *  baseUrl (string),
 *  agentId (number),
 *  assessorId (number),
 *  domainUrl (string),
 *  isWhatsApp (boolean),
 *  isMicrophone (boolean),
 *  withAssessor  (boolean),
 *  withAttachment (boolean),
 *  previewMode (boolean),
 *  version ("v1" | "v2")
 *  withInitialMessage (boolean)
 * }
 * */
function stringFormat({
    baseUrl,
    agentId,
    assessorId,
    domainUrl,
    withWhatsApp,
    withMicrophone,
    withAssessor,
    withAttachment,
    previewMode = false,
    withInitialMessage,
    version = 'v1',
    defaultCountry,
    countries,
}) {
    return `
       ((isPreview) => {
       
       const countries = ${JSON.stringify(countries)},
         defaultCountry = "${defaultCountry}",
         baseUrl = "${baseUrl}",
         domainImagesUrl = "${domainUrl}",
         audio = new Audio('${domainUrl}sounds/pop-bot.mp3'),
         versionBot = "${version}",
         agent_id = ${agentId},
         is_whatsapp = ${withWhatsApp},
         is_microphone = ${withMicrophone},
         with_assessor = ${withAssessor},
         with_attachment = ${JSON.stringify(withAttachment)},
         with_initial_message = ${withInitialMessage},
         idAgent = "agent-${agentId}",
         sessionKey = 'twilio-chat-session-${agentId}-${version}',
         agent_key = ${assessorId};
        
        let conversation = null,
         config = null,
         extraMetadata = {},
         data = null,
         recorder = null,
         client = null,
         locationData = null,
         session = localStorage.getItem(sessionKey) ? JSON.parse(localStorage.getItem(sessionKey)) : null;
        ${playSound}
        ${closeRoleContent}
        ${stateMessage}
        ${alertNativeBot}
        const loginEvent = ${loginListenerFromParent};
        loginEvent();
        ${loadingBot}
        ${messageFormat}
        ${formatMarkdown}
        ${replaceCodeWithEmojis}
        ${getTemplateComponentByKeyService}
        ${botEventService}
        ${openCloseChat}
        ${finalizeChat}
        const validate = ${validateSessionExpiration};
        ${startSessionForPreview}
        ${addMessageToBody}
        ${removeIfExistWaiting}
        ${loadMessages}
        ${setMessage}
        ${onStartTwilioConversation}
        ${initConversation}
        ${formatSuggestionItem}
        ${messageToSendBodyHtml}
        ${messageToReceiveBodyHtml}
        ${findParent}
        ${formatBot}
        ${onSubmitData}
        ${selectCountriesToBody}
        ${actionAssessorClick}
        ${actionMicrophoneMouseDown}
        ${actionMicrophoneMouseUp}   
        ${onSubmitSession}
        ${getDownloadImage}
        ${getPdfImage}
        ${getEyeImage}
        ${authenticationService}
        ${getFilesFormatToInput}
        ${initBot}
        ${trackEvent}
        ${hideRoleContent}
        const onStart = ${startBotContent};
        validate().then(res => {
            const existsScript = document.getElementById('twilio-conversations-script');
            if (existsScript) existsScript.remove();
            const buttonPlay = document.createElement('button');
            buttonPlay.id = "button-play" + idAgent;
            buttonPlay.style.visibility = 'hidden';
            buttonPlay.addEventListener('click', (e) => {
               audio.loop = false;
               audio?.play?.().then().catch();
            })
            document.body.appendChild(buttonPlay);
            const script = document.createElement('script');
            script.id = 'twilio-conversations-script';
            script.src = 'https://media.twiliocdn.com/sdk/js/conversations/v2.4/twilio-conversations.min.js';
            script.crossOrigin = "anonymous";
            document.head.appendChild(script);  
            script.onload = onStart;
        });
        
       })(${previewMode});     
       `;
}

export {
    stringFormat,
    formatBot,
    startSessionForPreview,
    addMessageToBody,
    removeIfExistWaiting,
    loadMessages,
    setMessage,
    onStartTwilioConversation,
    initConversation,
    formatSuggestionItem,
    messageToSendBodyHtml,
    messageToReceiveBodyHtml,
    openCloseChat,
    findParent,
    onSubmitData,
    actionAssessorClick,
    actionMicrophoneMouseDown,
    actionMicrophoneMouseUp,
    onSubmitSession,
    authenticationService,
    initBot,
    playSound,
    messageFormat,
    getTemplateComponentByKeyService,
    loadingBot,
    stateMessage,
    closeRoleContent,
    hideRoleContent,
    formatMarkdown,
};
